import { createPageLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs';
import { INACCESSIBLE_PAGE_LOAD_KEY } from '@confluence/browser-metrics/entry-points/metric-keys';

export const INACCESSIBLE_PAGE_LOAD = createPageLoadMetric({
	key: INACCESSIBLE_PAGE_LOAD_KEY,
});
